/**********************************************************
Hawaiian Macadamia Nut Services
Alexander Self
7/17/20
Valve table component: called in irrigation_create
**********************************************************/
import { sumProp } from '../irrigation_utils';
import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
  valves: PropTypes.array,
  valveLog: PropTypes.array
};

const ValveTable = ({ valves, valveLog }) => {
  return (
    <div className="irr-log-table">
      <table className="responsive-table bordered highlight centered">
        <thead>
          <tr>
            <th>Valve</th>
            <th>Gal/min</th>
            <th>Hours</th>
            <th>Gallons</th>
          </tr>
        </thead>
        <tbody>
          { 
            valveLog.map((v) => {
              let valve = valves.find((_v) => _v.id === v.valveId);
              return (
                <tr key={v.valveId}>
                  <td>{ valve === undefined ? '' : valve.valveNo }</td>
                  <td>{ valve === undefined ? '' : valve.galPerMinute }</td>
                  <td>{ v.hours }</td>
                  <td>{ v.totalGal }</td>
                </tr>
              )
            })
          }
        </tbody>
        <tfoot className="hide-on-med-and-down">
          <tr>
            <td><center>Totals</center></td>
            <td></td>
            <td><center><b>{ valveLog.length > 0 ? sumProp('hours', valveLog): 0 }</b></center></td>
            <td><center><b>{ valveLog.length > 0 ? sumProp('totalGal', valveLog): 0 }</b></center></td>
          </tr>
        </tfoot>
      </table>
    </div>
  );
}


ValveTable.propTypes = propTypes;
export default ValveTable;



/* END */



// WEBPACK FOOTER //
// ./src/irrigation/components/valve_table.js